export default __webpack_public_path__ + "static/media/Pathfinder-Logo-(Green).45a052b1.jpg";